import s from "./PreparePage.module.css";
import { SvgLogo } from "assets/svg";
import ProgressBar from "components/ProgressBar";
import { useAuthContext } from "context/AuthContext";
import { Link, useNavigate } from "react-router-dom";

function PreparePage() {
    const navigate = useNavigate();
    const { user } = useAuthContext();

    const handlePrevStep = () => {
        if (user.group.group_name === "B") {
            navigate("/entrance_pay");
        } else {
            navigate("/app_download");
        }
    };

    return (
        <div className={s.root}>
            <ProgressBar step={4} handlePrevStep={handlePrevStep} />
            <div className={s.logo}>
                <SvgLogo />
            </div>
            <div className={s.content}>
                Every day you now will mark your rise in the web version, so save it in bookmarks.
            </div>
            <Link
                to={"/kickoff"}
                className="md:fixed md:bottom-[32px] w-full flex justify-center md:w-[600px] mt-[90px]"
            >
                <div className={s.continueButton}>Continue</div>
            </Link>
        </div>
    );
}

export default PreparePage;
